module.exports = fox._r("images/bg/models_block_bg.jpg", __webpack_public_path__ + "images/bg/models_block_bg.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/bg/models_block_bg.jpg
// module id = 158
// module chunks = 5